// import { Navigate, Outlet } from "react-router-dom";
// import MainLayout from "../layout/MainLayout";
// import { useFetchGetMe } from "hooks/usersHooks";
// import LoginForm from "pages/Login";

// type roleType = {
//   roles: string[];
// };

// const ProtectedRoute = ({ roles }: roleType) => {
//   const { data } = useFetchGetMe();
//   const currentRole = data?.roles[0]?.name;

//   if (!data.roles[0].name) return <Navigate to="/login" replace />;

//   if (roles && !roles.includes(currentRole)) {
//     return <Navigate to="403" replace />;
//   }

//   const token = localStorage.getItem("token");
//   return token ? (
//     <MainLayout>
//       <Outlet />
//     </MainLayout>
//   ) : (
//     <Navigate to="/login" />
//   );
// };

// export default ProtectedRoute;
// import { Navigate, Outlet } from "react-router-dom";
// import MainLayout from "../layout/MainLayout";
// import { useFetchGetMe } from "hooks/usersHooks";

// type ProtectedProps = {
//   roles: string[];
// };

// const ProtectedRoute = ({ roles }: ProtectedProps) => {
//   const { data, isLoading, error } = useFetchGetMe();
//   const token = localStorage.getItem("token");

//   // 1) No token → login
//   if (!token) return <Navigate to="/login" replace />;

//   // 2) Still loading → avoid crash
//   if (isLoading) return null;

//   // 3) Invalid response → login
//   if (error || !data || !data.roles || data.roles.length === 0)
//     return <Navigate to="/login" replace />;

//   const currentRole = data.roles[0].name;

//   // 4) Role check

//   if (roles && !roles.includes(currentRole)) {
//     return <Navigate to="/403" replace />;
//   }

//   // 5) Allowed
//   return (
//     <MainLayout>
//       <Outlet />
//     </MainLayout>
//   );
// };

// export default ProtectedRoute;

import { Navigate, Outlet } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import { useFetchGetMe } from "hooks/usersHooks";
import { canAny } from "utils/access";
import { normalizeRoleName } from "utils/roles";

type ProtectedProps = {
  roles?: string[];
  /** Also allowed when the user has any of these backend permissions (e.g. `view_roles`). */
  permissions?: string[];
  /** When false, only gate roles — parent route already provides MainLayout. */
  withLayout?: boolean;
};

const normalize = normalizeRoleName;

const ProtectedRoute = ({ roles, permissions, withLayout = true }: ProtectedProps) => {
  const { data, isLoading, isFetching, error } = useFetchGetMe({ enabled: true });
  const token = localStorage.getItem("token");

  // 1) No token → login
  if (!token) return <Navigate to="/login" replace />;

  // 2) Loading — show spinner instead of blank white screen
  if (isLoading || (isFetching && !data)) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          color: "#717680",
          fontSize: 14,
        }}
      >
        Loading...
      </div>
    );
  }

  // 3) Invalid user
  if (error || !data?.roles?.length) {
    return <Navigate to="/login" replace />;
  }

  // normalize user roles
  const userRoles = data.roles.map((r: any) => normalize(r.name));

  // normalize allowed roles
  const allowedRoles = roles?.map(normalize);

  // 4) Role check
  const roleAllowed = !allowedRoles || userRoles.some((r: any) => allowedRoles.includes(r));
  const permissionAllowed = !!permissions?.length && canAny(data, permissions);
  if (!roleAllowed && !permissionAllowed) {
    return <Navigate to="/403" replace />;
  }

  // 5) Allowed — nested gates must not wrap MainLayout again (double sidebar)
  if (!withLayout) {
    return <Outlet />;
  }

  return (
    <MainLayout userRole={userRoles}>
      <Outlet />
    </MainLayout>
  );
};

export default ProtectedRoute;
